<template>
  <div class="md-layout">
    <div class="md-layout">
      <!-- <div class="md-layout-item md-size-20 md-small-size-30 md-medium-size-30 md-xsmall-size-30">
        <product-card header-animation="false">
          <div slot="imageHeader" style="background-color:white">
            <img class="img" :src="selectedWine ? selectedWine.pictureThumbnail : defaultAvatar" />
          </div>
          <h4 slot="title" class="title">
            <p>{{ selectedWine ? selectedWine.id : "" }}</p>
          </h4>
          <div class="md-layout-item md-size-100" slot="description">
            <ValidationObserver>
              <md-autocomplete v-model="selectedWineName" :md-options="listWineName" md-dense>
                <label>Tên sản phẩm</label>
              </md-autocomplete>
            </ValidationObserver>
          </div>
        </product-card>
      </div>-->
      <div class="md-layout-item md-size-100">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                  <md-icon>account_balance</md-icon>
                </div>
                <div class="w-full flex-sb flex-m">
                  <h4 class="title">Thông tin nhập kho</h4>
                  <md-button class="md-sm" @click="userClickInputFile">Import excel</md-button>
                  <input type="file" hidden id="importFile" @change="changeInputFile" />
                </div>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <md-icon>account_box</md-icon>
                        <label>Mã phiếu nhập:</label>
                        <md-input v-model="form.inboundId" required></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-datepicker v-model="form.date" :md-immediately="true">
                        <label>Ngày nhập:</label>
                      </md-datepicker>
                    </div>
                  </div>
                  <div class="md-layout-item">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Ghi chú:</label>
                        <md-textarea v-model="form.note" :md-autogrow="true"></md-textarea>
                        <md-icon>article</md-icon>
                      </md-field>
                    </div>
                  </div>
                </div>
                <h5>Danh sách sản phẩm</h5>
                <div class="w-full">
                  <md-button class="md-success md-sm" @click="addProducts()">Thêm sản phẩm</md-button>
                </div>

                <div class="scroll-x">
                  <table id="customer" class="table-products">
                    <tr>
                      <th>STT</th>
                      <th>Mã sản phẩm</th>
                      <th style="width: 60%">Tên sản phẩm</th>
                      <th>Đơn vị</th>
                      <th>Số lượng nhập</th>
                      <th>Xóa</th>
                    </tr>
                    <tr :key="index" v-for="(item, index) in form.listProducts">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.productId }}</td>
                      <td>
                        {{
                            item.name.length > 60
                              ? item.name.substring(0, 60) + "..."
                              : item.name
                        }}
                        <md-tooltip v-show="item.name.length > 60">{{
                            item.name
                        }}</md-tooltip>
                      </td>
                      <td>{{ item.unit }}</td>
                      <td>
                        <md-field>
                          <md-input type="number" v-model="item.quanity" required></md-input>
                        </md-field>
                      </td>
                      <td style="color: red" class="clickable" @click="removeItem(index)">
                        <i class="fas fa-trash-alt"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </md-card-content>
              <h5 v-if="form.isImportExcel" style="color: red">Chú ý: Nhập kho từ file Excel sẽ gán giá trị tồn kho của
                các sản phẩm khác về 0 !!</h5>
              <md-card-actions>
                <md-button class="md-success" type="submit">Nhập kho</md-button>
              </md-card-actions>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon" v-bind:class="{ clickable: isShowDetail }">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Lịch sử nhập kho</h4>
        </md-card-header>
        <md-card-content>
          <!-- <md-button @click="updateAll">Update All</md-button> -->
          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <md-datepicker v-model="inboundDate" :md-immediately="true">
                <label>Ngày nhập:</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-size-40 md-xsmall-zise-50">
              <md-autocomplete v-model="searchname" :md-options="listWineName" @md-selected="
                (inboundHistory = []),
                getData(null, null, pagination.perPage * 2)
              " md-dense>
                <label>Tên sản phẩm</label>
              </md-autocomplete>
            </div>
          </div>
          <div class="scroll-x">
            <table class="table-warehouse">
              <tr>
                <th>Mã phiếu nhập</th>
                <th>Ngày nhập</th>
                <th>Sản phẩm</th>
                <th class="nummeric">Đơn vị</th>
                <th class="nummeric">Số lượng</th>
                <th>Ghi chú</th>
              </tr>
              <tr :key="index" v-for="(item, index) in queriedData">
                <td style="vertical-align: top">{{ item.data.inboundId }}</td>
                <td style="vertical-align: top">
                  {{ formatDate(new Date(item.data.date)).substring(0, 11) }}
                </td>
                <td>
                  <div class="borderx" v-for="(e, i) in item.data.listProducts.filter(
                    (product, index) =>
                      index <
                      (listSeeMore.includes(item)
                        ? item.data.listProducts.length
                        : 5)
                  )" :key="i">
                    - {{ e.name }}
                  </div>
                  <div class="clickable seeMore" v-if="item.data.listProducts.length > 6" @click="seeMore(item)">
                    {{ listSeeMore.includes(item) ? "Ẩn bớt" : "Xem thêm" }}
                  </div>
                </td>
                <td class="nummeric">
                  <div class="borderx" v-for="(e, i) in item.data.listProducts.filter(
                    (product, index) =>
                      index <
                      (listSeeMore.includes(item)
                        ? item.data.listProducts.length
                        : 5)
                  )" :key="i">
                    {{ e.unit }}
                  </div>
                </td>
                <td class="nummeric">
                  <div class="borderx" v-for="(e, i) in item.data.listProducts.filter(
                    (product, index) =>
                      index <
                      (listSeeMore.includes(item)
                        ? item.data.listProducts.length
                        : 5)
                  )" :key="i">
                    {{ e.quanity }}
                  </div>
                </td>
                <td style="vertical-align: top">{{ item.data.note }}</td>
              </tr>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Hiển thị lịch sử nhập kho từ {{ from + 1 }} đến {{ to }}
            </p>
          </div>
          <!-- <ul class="pagination">
            <li class="page-item prev-page">
              <a class="page-link" aria-label="Previous" @click="prevPage">
                <md-button class="md-simple md-sm">
                  <i class="fas fa-angle-double-left"></i>
                  Trang trước
                </md-button>
              </a>
            </li>
            <li class="page-item page-pre next-page">
              <a class="page-link" aria-label="Next" @click="nextPage">
                <md-button class="md-simple md-sm">
                  Trang sau
                  <i class="fas fa-angle-double-right"></i>
                </md-button>
              </a>
            </li>
          </ul> -->
          <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
            :per-page="pagination.perPage" :total="total">
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
    <modal-add-products v-if="isAddProducts" @smallAlertModalHide="smallAlertModalHide"
      :listProductsSelected="form.listProducts"></modal-add-products>
  </div>
</template>
<script>
import { Pagination } from "@/components";
import firebase from "@/services/firebase-init.js";
import { readWarehouseData } from "../../utils/index";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalAddProducts: () => import("./modalAddProducts.vue"),
    Pagination,
  },

  data() {
    return {
      listSeeMore: [],
      isShowDetail: false,
      isAddProducts: false,
      listWine: {},
      listWineName: [],
      selectedWineName: null,
      selectedWine: null,
      inboundHistory: [],
      itemSelected: [],
      db: {},
      form: {
        date: new Date(),
        inboundId: "",
        note: "",
        listProducts: [],
        productsFilter: [],
        time: null,
        isImportExcel: false,
      },
      defaultAvatar: "./img/default_bottle.png",
      pagination: {
        currentPage: 1,
        endOfData: true,
        perPage: 20,
      },
      inboundDate: null,
      searchname: "",
    };
  },

  async created() {
    this.db = firebase.firestore();
    this.$store.dispatch("FLAG_LOADING", true);
    let bits = localStorage.getItem("bits");
    let tmp = await this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_WINE + bits)
      .get();
    //console.log(tmp.data());
    tmp.data().listWine.forEach((wine) => {
      this.listWineName.push(wine.name);
      this.listWine[wine.name] = wine;
    });
    this.listWineName.sort();
    this.getData(null, null, this.pagination.perPage * 2);
    this.listProducts = JSON.parse(JSON.stringify(this.$listProducts));
    this.listProducts = this.listProducts.filter(
      (item) => item.data.isHide !== true
    );
    this.db
      .collection(process.env.VUE_APP_WINE + bits)
      .where("tags", "array-contains", "Phụ kiện")
      .orderBy("name")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.listProducts.push({
            data: doc.data(),
            id: doc.id,
          });
        });
        this.listProducts = this.listProducts.filter(
          (item) => item.data.isHide !== true
        );
        this.$store.dispatch("FLAG_LOADING", false);
      });
  },

  methods: {
    // updateAll() {
    //   console.log(this.inboundHistory);
    //   this.inboundHistory.forEach(item => {
    //     this.db
    //       .collection(process.env.VUE_APP_WAREHOUSE_INBOUNDS)
    //       .doc(item.id)
    //       .update({
    //         date: item.data.date,
    //         listProducts: [
    //           {
    //             name: item.data.productName,
    //             productId: item.data.productId,
    //             quanity: item.data.quanity
    //           }
    //         ],
    //         name: item.data.name,
    //         note: item.data.note,
    //         productsFilter: [item.data.productName],
    //         time: item.data.time,
    //         warehouseName: "Kho Hà Nội"
    //       })
    //       .then(() => console.log("success"))
    //       .catch(error => console.log(error))
    //   });
    // },
    userClickInputFile() {
      document.getElementById("importFile").click();
    },
    addDataFromFile(warehouseData) {
      let warehouseDataId = warehouseData.map((item) => item.id);
      let dataAdd = this.listProducts.filter((item) =>
        warehouseDataId.includes(item.data.productId)
      );
      dataAdd.forEach((item) => {
        let index = warehouseData.findIndex(
          (e) => e.id === item.data.productId
        );
        item = {
          name: item.data.name,
          productId: item.data.productId,
          quanity: warehouseData[index].value,
          unit: item.data.unit,
        };
        let check = false;
        this.form.listProducts.forEach((product) => {
          if (product.name === item.name) {
            check = true;
          }
        });
        if (!check) {
          this.form.listProducts.push(item);
        }
      });
    },
    async changeInputFile(evt) {
      const file = evt.target.files[0];
      const data = await file.arrayBuffer();
      const warehouseData = readWarehouseData(data);
      this.addDataFromFile(warehouseData);
      this.form.isImportExcel = true;
      console.log(this.form.isImportExcel);
    },
    seeMore(item) {
      var index = this.listSeeMore.findIndex((el) => el === item);
      if (index !== -1) {
        this.listSeeMore.splice(index, 1);
      } else this.listSeeMore.push(item);
    },
    removeProduct(index) {
      this.form.listProducts.splice(index, 1);
    },
    addProducts() {
      this.isAddProducts = true;
    },
    smallAlertModalHide(e) {
      this.isAddProducts = false;
      e.forEach((item) => {
        item = {
          name: item.data.name,
          productId: item.data.productId,
          quanity: null,
          unit: item.data.unit,
        };
        let check = false;
        this.form.listProducts.forEach((product) => {
          if (product.name === item.name) {
            check = true;
          }
        });
        if (!check) {
          this.form.listProducts.push(item);
        }
      });
    },
    async submit() {
      let self = this;
      let check = false;
      if (this.form.listProducts.length === 0) {
        alert("Hãy chọn sản phẩm để nhập trước");
      } else if (this.form.date == null) {
        alert("Hãy chọn ngày nhập kho");
      } else {
        this.form.listProducts = this.form.listProducts.map((item) => {
          item.quanity = parseInt(item.quanity);
          return item;
        });
        this.form.productsFilter = this.form.listProducts.map(
          (item) => item.name
        );
        this.form.time = new Date().valueOf();
        this.form.date = this.form.date.valueOf();
        this.$store.dispatch("FLAG_LOADING", true);
        //console.log(this.form);
        let bits = localStorage.getItem("bits");
        await this.db
          .collection(process.env.VUE_APP_WAREHOUSE_INBOUNDS + bits)
          .add(this.form)
          .then(function (docRef) {
            //console.log(docRef);
            self.$store.dispatch("FLAG_LOADING", false);
            self.$messageSuccess("Nhập kho thành công");
          })
          .catch(function (error) {
            console.log(error);
            self.$store.dispatch("FLAG_LOADING", false);
            self.$messageError("Có lỗi xảy ra");
          });
        self.form = {
          date: new Date(),
          inboundId: "",
          note: "",
          listProducts: [],
          time: null,
        };
        self.getData(null, null, self.pagination.perPage * 2);
      }
    },
    async getData(lastData, firstData, limit) {
      let bits = localStorage.getItem("bits");
      let query = this.db.collection(
        process.env.VUE_APP_WAREHOUSE_INBOUNDS + bits
      );
      this.$store.dispatch("FLAG_LOADING", true);
      query = query.orderBy("time", "desc");
      query = query.limit(limit);
      if (this.inboundDate) {
        query = query.where("date", "==", this.inboundDate.valueOf());
      }
      if (this.searchname) {
        query = query.where(
          "productsFilter",
          "array-contains",
          this.searchname
        );
      }
      if (lastData) {
        let docRef = this.db
          .collection(process.env.VUE_APP_WAREHOUSE_INBOUNDS + bits)
          .doc(lastData);
        let snapshot = await docRef.get();
        query = query.startAfter(snapshot);
      }
      if (firstData) {
        let docRef = this.db
          .collection(process.env.VUE_APP_WAREHOUSE_INBOUNDS + bits)
          .doc(firstData);
        let snapshot = await docRef.get();
        query = query.endBefore(snapshot);
      }
      this.$store.dispatch("FLAG_LOADING", true);
      await query.get().then((doc) => {
        doc.forEach((item) => {
          this.inboundHistory.push({
            id: item.id,
            data: item.data(),
          });
        });
        this.$store.dispatch("FLAG_LOADING", false);
      });
    },
    removeItem(index) {
      this.form.listProducts.splice(index, 1);
    },
    prevPage() {
      if (this.pagination.currentPage != 1) {
        this.pagination.currentPage -= 1;
        this.getData(null, this.inboundHistory[0].id, this.pagination.perPage);
      }
    },
    nextPage() {
      if (this.inboundHistory.length == 10) {
        this.pagination.currentPage += 1;
        this.getData(
          this.inboundHistory[this.inboundHistory.length - 1].id,
          null,
          this.pagination.perPage
        );
      } else {
        alert("Đã hết dữ liệu");
      }
    },
  },
  computed: {
    ...mapGetters(["$listProducts"]),
    queriedData() {
      let result = this.inboundHistory;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.inboundHistory.length;
    },
  },
  watch: {
    inboundDate: function (newVal, oldVal) {
      if (newVal != null) {
        this.inboundHistory = [];
        this.getData(null, null, this.pagination.perPage * 2);
      }
    },
    "pagination.currentPage"() {
      if (this.pagination.currentPage >= this.total / this.pagination.perPage) {
        this.getData(
          this.inboundHistory[this.inboundHistory.length - 1].id,
          null,
          this.pagination.perPage
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  width: auto !important;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 250px;
}

.product {
  border: solid rgba(0, 0, 0, 0.315) 1px;
  border-radius: 10px;
  text-align: left;
  margin: 5px;
  padding: 5px;
  max-width: 400px;
  background: rgb(243, 243, 243);
}

.remove {
  position: absolute;
}

.table-warehouse {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
}

.borderx {
  padding: 3px;
  border-bottom: 0.5px solid rgb(206, 204, 204);
}

.table-warehouse td {
  border: 1px solid rgb(190, 189, 189);
  padding: 8px 10px 8px 10px;
  max-width: 20vh;
  vertical-align: top;
}

.table-warehouse td div {
  height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-warehouse th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vh;
}

.table-warehouse tr:nth-child(even) {
  background-color: #f2f2f2;
}

// .table-warehouse tr:hover {
//   background-color: #ddd;
// }

.table-warehouse th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}

.nummeric {
  text-align: right !important;
}

.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}

#customer {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
  overflow-x: scroll;
}

#customer td,
#customer th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vw;
}

#customer tr:hover {
  background-color: #ddd;
}

#customer th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}

.seeMore {
  color: rgba(0, 0, 0, 0.603);
  font-style: italic;
  text-decoration: underline;
}

.table-products {
  overflow-y: auto;
}
</style>
